import { useSelector } from 'react-redux';

export const useAppSelector = useSelector;

export const usewpdataSelectors = () => {
  const appSelector = useAppSelector;
  return {
    CleanSettings: appSelector((state) => state.wpdata.cleanSettings),
    Settings: appSelector((state) => state.wpdata.settings),
    Theme: appSelector((state) => state.wpdata.theme),
    Layout: appSelector((state) => state.wpdata.layout),
    DiscountBar: appSelector((state) => state.wpdata.discountBar),
    MiddleBar: appSelector((state) => state.wpdata.middleBar),
    Promotional: appSelector((state) => state.wpdata.promotional),
    About: appSelector((state) => state.wpdata.about),
    header: appSelector((state) => state.wpdata.header),
    hero: appSelector((state) => state.wpdata.hero),
    Usage: appSelector((state) => state.wpdata.usage),
    logoSlider: appSelector((state) => state.wpdata.logoSlider),
    videoTestimonials: appSelector((state) => state.wpdata.videoTestimonials),
    videoTestimonialsImages: appSelector((state) => state.wpdata.videoTestimonialsImages),
    TestimonialsSwiper: appSelector((state) => state.wpdata.testimonialsSwiper),
    productsSection: appSelector((state) => state.wpdata.productsSection),
    slidingTextBar: appSelector((state) => state.wpdata.slidingTextBar),
    CompetitorsComparison: appSelector((state) => state.wpdata.competitorsComparison),
    FeaturesList: appSelector((state) => state.wpdata.features),
    Statistics: appSelector((state) => state.wpdata.statistics),
    Setup: appSelector((state) => state.wpdata.setup),
    FAQ: appSelector((state) => state.wpdata.FAQ),
    Cart: appSelector((state) => state.wpdata.cart),
    Award: appSelector((state) => state.wpdata.awards),
    BaComparison: appSelector((state) => state.wpdata.baComparison),
    Expert: appSelector((state) => state.wpdata.expertBlock),
    customerReviewsBlock: appSelector((state) => state.wpdata.customerReviewsBlock),
    footer: appSelector((state) => state.wpdata.footer),
    bottomBanner: appSelector((state) => state.wpdata.bottomBanner),
    Floater: appSelector((state) => state.wpdata.FloatingCTA),
  };
};
